import { render, staticRenderFns } from "./ClientGeneral.vue?vue&type=template&id=32296684"
import script from "./ClientGeneral.vue?vue&type=script&lang=js"
export * from "./ClientGeneral.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports